import { Injectable } from '@angular/core';
import { DateUtils } from '@hglobal/utility-kit';

import { CsrfTokenData } from '../../auth/auth.abstraction';
import { DEFAULT_TIME_OFFSET_SECONDS } from '../../auth/auth.constant';

@Injectable({
  providedIn: 'root',
})
export class CrsfStorageService {
  private stored: CsrfTokenData | null = null;

  getCrsfToken(): string {
    if (!this.stored) {
      return '';
    }

    const currentTimeInSec = Math.floor(DateUtils.msToSec(Date.now()));
    const considerExpired = currentTimeInSec >= this.stored.expiresAt - DEFAULT_TIME_OFFSET_SECONDS;

    if (considerExpired) {
      return '';
    }

    return this.stored.csrfToken;
  }

  setCrsfTokenData(data: CsrfTokenData): void {
    this.stored = data;
  }

}
